<ng-container *ngIf="data != null">
  <div class="drop-down" appClickOutside (clickOutside)="onClickedOutside()">
    <button
      type="button"
      class="drop-down-box go-to-next"
      [class.is-invalid]="!data.isValid"
      [class.drop-down-box-open]="!listClosed"
      [class.is-disable]="data.isDisable"
      [ngClass]="data.buttonClass"
      (click)="openDropDown()"
    >
      <span>{{ selectedItem.friendlyName }}</span>
      <i class="fas fa-angle-down"></i>
    </button>
    <div
      id="drop-down-list-box"
      class="drop-down-fields-box"
      *ngIf="!listClosed"
      [ngClass]="{ 'drop-down-loading': loading }"
    >
      <div class="search-box-top">
        <form [formGroup]="drugSearchForm">
          <input
            id="drugBrandName"
            type="text"
            autocomplete="off"
            appSelectOnFocus
            formControlName="drugBrandName"
            class="form-control search-input-box search-input change-arrow-key"
            placeholder="{{ 'Search' | translate }}"
            [(ngModel)]="searchBox"
          />
        </form>
        <button
          type="button"
          class="btn btn-icon refresh-button"
          *ngIf="data.hasSearch == true"
          (click)="refreshButton()"
        >
          <i class="fas fa-sync-alt"></i>
        </button>
        <button
          type="button"
          *ngIf="searchBox != '' && searchBox != null"
          (click)="emptySearch()"
        >
          <i class="far fa-times-circle"></i>
        </button>
      </div>

      <div
        class="items-list px-2 py-1 change-arrow-key"
        *ngFor="let item of dropDownData"
      >
        <button type="button" (click)="selectItem(item)">
          <span>{{ item.friendlyName }}</span>
        </button>
      </div>

      <div class="paging-box">
        <app-pcpaging
          [paging]="paging"
          [isDropDown]="true"
          (parentAction)="parentAction($event)"
        >
        </app-pcpaging>
      </div>

      <div class="add-box" *ngIf="data.hasAdd">
        <input
          class="form-control change-arrow-key"
          type=" text"
          [placeholder]="'add' | translate"
          [(ngModel)]="NewName"
        />
        <button type="button" (click)="addButton()">
          <i class="far fa-plus-square"></i>
        </button>
      </div>
      <app-loading-panel *ngIf="loading"></app-loading-panel>
    </div>
  </div>
</ng-container>
